import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { formatCurrencyToFixed } from "src/shared/hooks/formatCurrency"
import { PropinasDetailProps } from "./PropinasDetail.type"
import "./PropinasDetail.css"

const emptyValue = "-"

const PropinasDetail = ({ isOpen, onClose, data }: PropinasDetailProps): JSX.Element => {
    // la fecha del reporte ya llega formateada desde el endpoint, se muestra igual que en la tabla
    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="propinas-detail">
            <div className="propinas-detail__head">
                <p className="propinas-detail__title">Propina</p>
            </div>
            <div className="propinas-detail__body">
                <div className="propinas-detail__description">
                    <DescriptionDetail
                        icon={"calendarChecked"}
                        label={"Fecha de registro"}
                        value={data?.fecha_registro || emptyValue}
                    />
                    <DescriptionDetail
                        className={"propinas-detail__value--full"}
                        icon={"userFilled"}
                        label={"Persona"}
                        value={data?.colaborador || emptyValue}
                    />
                    <DescriptionDetail icon={"buildingTwo"} label={"Área"} value={data?.area || emptyValue} />
                    <DescriptionDetail icon={"SuitcaseFill"} label={"Puesto"} value={data?.puesto || emptyValue} />
                    <DescriptionDetail
                        icon={"handCoin"}
                        label={"Puntos a pagar"}
                        value={data?.puntos_a_pagar || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"BankCard"}
                        label={"Utilidad por puntos"}
                        value={formatCurrencyToFixed(Number(data?.utilidad_por_puntos) || 0)}
                    />
                    <DescriptionDetail
                        icon={"Percent"}
                        label={"Comisión bancaria"}
                        value={formatCurrencyToFixed(Number(data?.comision_bancaria) || 0)}
                    />
                    <DescriptionDetail
                        icon={"dollarCircle"}
                        label={"Total pagado"}
                        value={formatCurrencyToFixed(Number(data?.pago_a_colaborador) || 0)}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default PropinasDetail
